export function debounce<F extends (...args: any[]) => any>(func: F, wait: number) {
    let timeout: NodeJS.Timeout | null;

    return function executedFunction(...args: Parameters<F>): ReturnType<F> | void {
        const later = () => {
            clearTimeout(timeout!);
            return func(...args);
        };

        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, wait);
    };
}
